<template>
  <div class="login">
    <div class="wavy-line"></div>
    <div class="login-box">
      <div class="login-form-box">
        <img src="~@/assets/img/login/loginbox-banner.png" class="login-banner">
<!--        <h4 class="login-box_title">芒哥项目报告数据</h4>-->
        <div class="login-type">
          <div :class="{'activate':activate == 3}" @click="selectType(3)">综合服务商端</div>
          <div :class="{'activate':activate == 1}" @click="selectType(1)">项目服务商端</div>
          <div :class="{'activate':activate == 2}" @click="selectType(2)">授权登录</div>
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="0" size="mini" v-if="activate == 2">
          <el-form-item prop="phone" style="margin-bottom: 30px;">
            <div class="list-item">
              <img src="~@/assets/img/login/icon_phone.png" class="label-icon">
              <div class="list-item_inner">
                <el-input v-model="form.phone" maxlength="11" placeholder="请输入手机号"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="sms">
            <div class="list-item">
              <img src="~@/assets/img/login/icon_password.png" class="label-icon">
              <div class="list-item_inner">
                <el-input v-model="form.sms" placeholder="请输入验证码"></el-input>
                <el-button type="primary" class="send-sms" :disabled="state.smsSendBtn" @click.stop.prevent="getCaptcha" v-text="
                    (!state.smsSendBtn && '获取验证码') ||
                      state.time + '秒后获取'
                  "></el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item style="text-align: center;">
            <el-button type="primary" class="submit-btn" size="medium" :loading="state.submitBtn" @click="onSubmit('form')">登 录</el-button>
          </el-form-item>
        </el-form>
        <el-form :model="serveForm" :rules="serveRules" ref="serveForm" label-width="0" size="mini" v-if="activate == 1||activate == 3">
          <el-form-item prop="login_account" style="margin-bottom: 30px;">
            <div class="list-item">
              <img src="~@/assets/img/login/icon_phone.png" class="label-icon">
              <div class="list-item_inner list-item_all_width">
                <el-input v-model="serveForm.login_account" maxlength="20" placeholder="请输入账号"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="list-item">
              <img src="~@/assets/img/login/icon_password.png" class="label-icon">
              <div class="list-item_inner list-item_all_width">
                <el-input v-model="serveForm.password" placeholder="请输入密码" show-password></el-input>
              </div>
            </div>
          </el-form-item>
          <el-button type="text" v-if="activate == 1||activate == 3" @click="retrievePassword" class="password-txt">忘记密码</el-button>
          <el-form-item style="text-align: center;">
            <el-button type="primary" class="submit-btn" size="medium" :loading="serveLoading" @click="onSubmit('serveForm')">登 录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      class="page-footer"
      v-bind:class="{ collapsed: $store.state.collapsed }"
    >
      Copyright &copy;{{ currentYear }} by 上海正也信息科技有限公司
      <a href="https://beian.miit.gov.cn/" class="beian" target="_blank"
      >沪ICP备14016032号-7</a
      >
    </div>
  </div>
</template>

<script>
import { sendSms } from '@/api/common';
import { userLogin, serveLogin } from '@/api';
import { trim } from '@/utils/util';

export default {
  name: 'login',
  beforeCreate() {
    this.currentYear = new Date().getFullYear()
    console.log(this.$route.query)
  },
  data: () => ({
    activate: 3,
    state: {
      smsSendBtn: false,
      time: 60,
      submitBtn: false,
    },
    form: {
      phone: '',
      sms: '',
    },
    rules: {
      phone: [
        {
          required: true,
          message: '请输入手机号',
          trigger: 'blur',
        },
        {
          pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
          message: '手机号格式不正确',
          trigger: 'blur',
        },
      ],
      sms: [
        {
          required: true,
          message: '请输入验证码',
          trigger: 'blur',
        },
      ],
    },
    serveRules: {
      login_account: [
        {
          required: true,
          message: '请输入账号',
          trigger: 'blur',
        },
      ],
      password: [
        {
          required: true,
          message: '请输入密码',
          trigger: 'blur',
        },
      ],
    },
    serveForm: {
      login_account: '',
      password: '',
    },
    serveLoading: false,
  }),
  created() {

    if(this.$route.query.activate){
      this.activate=this.$route.query.activate
    }

  },
  methods: {
    // 发送验证码
    getCaptcha(e) {
      e.preventDefault();
      const that = this;
      if (that.state.isSending) {
        return;
      }
      const formValues = { ...this.form };

      if (/^[1][2,3,4,5,6,7,8,9][0-9]{9}$/.test(formValues.phone)) {
        that.state.isSending = true;
        const interval = window.setInterval(() => {
          that.state.smsSendBtn = true;
          if (that.state.time-- <= 0) {
            that.state.time = 60;
            that.state.smsSendBtn = false;
            that.state.isSending = false;
            window.clearInterval(interval);
          }
        }, 1000);

        that.$message({
          type: 'info',
          message: '验证码发送中...',
        });
        sendSms(formValues.phone)
          .then((res) => {
            if (res.status === 0) {
            } else {
              this.$message.error(res.msg);
              window.clearInterval(interval);
              that.state.time = 60;
              that.state.smsSendBtn = false;
              that.state.isSending = false;
            }
          })
          .catch((err) => {
            window.clearInterval(interval);
            that.state.time = 60;
            that.state.smsSendBtn = false;
            this.requestFailed(err);
            that.state.isSending = false;
          });
      } else {
        that.$message.error('请填写正确的手机号');
      }
    },
    onSubmit(formName) {
      if (formName == 'form') {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const formValues = { ...this.form };
            this.state.submitBtn = true;
            userLogin({
              phone: formValues.phone,
              sms: trim(formValues.sms),
            })
              .then((res) => {
                if (res.status === 0) {
                  this.$router.push({ name: 'home' });
                } else {
                  this.requestFailed(res);
                }
              })
              .catch((err) => {
                this.requestFailed(err);
              });
          }
        });
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const formValues = { ...this.serveForm };
            formValues.is_int_server = this.activate == 3 ? 1 : '0';
            this.serveLoading = true;
            serveLogin(formValues).then((res) => {
              if (res.status === 0) {
                this.serveLoading = false;
                console.log(this.activate);
                if (this.activate == 3) {
                  window.location.href = '/inter-service/#/systemSet/SystemSupport';
                } else if (this.activate == 1) {
                  window.location.href = '/service/#/systemSet/SystemSupport';
                }
              } else {
                this.requestFailed(res);
                this.serveLoading = false;
              }
            })
              .catch((err) => {
                this.requestFailed(err);
              });
          }
        });
      }
    },
    requestFailed(err) {
      const errMsg = (err.data && err.data.msg) || err.msg || '请求出现错误，请稍后再试';
      this.$message.error(errMsg);
      this.state.submitBtn = false;
    },
    selectType(type) {
      this.activate = type;
      this.serveForm.password = '';
      this.serveForm.login_account = '';
    },
    retrievePassword() {
      this.$router.push({ name: 'RetrieveThePassword', params: { type: this.activate } });
    },
  },
};
</script>

<style lang="scss" scoped>
  .login {
    position: relative;
    width: 100%;
    height: 100%;
    background: #f4cc43;
    background-size: auto 100%;
    .wavy-line {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 236px;
      background: url('~@/assets/img/login/img_wavy_line.png') no-repeat;
      background-size: 100% 100%;
    }
    .login-box {
      position: absolute;
      top: 50%;
      left: 50%;
      padding: 46px;
      width: 1092px;
      height: 624px;
      transform: translate(-50%, -50%);
      background: url('~@/assets/img/login/img_login_box.png') no-repeat;
      background-size: 100% 100%;
      .login-form-box {
        float: right;
        padding: 80px 75px 10px 100px;
        width: 50%;
        height: 100%;
        .login-banner{
          display:block;
          margin: 0 auto;
        }
        .login-box_title{
          margin: 20px 0;
          font-size: 20px;
          font-weight: 300;
          color: #000;
          text-align: center;
        }
      }
    }
    .list-item{
      position: relative;
      padding-left: 28px;
      .label-icon{
        position: absolute;
        top:0;
        left: 0;
        width: 24px;
        height: 24px;
      }
      .list-item_inner{
        position: relative;
        padding-right: 84px;
        .send-sms{
          position: absolute;
          right: 0;
          top: 0;
          padding: 7px 6px;
          font-weight: 400;
          color: #864a24;
        }
      }
      .list-item_all_width{
        padding-right: 0!important;
      }
    }
    .submit-btn{
      margin-top: 34px;
      padding: 10px 90px;
      font-weight: 400;
      color: #864a24;
      width: 100%;
    }
  }
  .login-type{
    display: flex;
    div{
      flex: 1;
      text-align: center;
      padding: 13px 0;
      font-weight: 600;
      color: #959596;
      margin: 30px 0;
      cursor: pointer;
    }
    .activate{
      color: #6C3F21;
      position: relative;
    }
    .activate:after{
      content: "";
      position: absolute;
      bottom: 0;
      left: 7px;
      width: 95px;
      height: 3px;
      background: #6C3F21;
    }
  }
  .password-txt:hover{
    color: #0098FF;
  }
  .page-footer {
    position: fixed;
    bottom: 5px;
    left: 0;
    width: 100%;
    text-align: center;
    height: 16px;
    color: #fff;
    font-size: 11px;
    .beian {
      color: #fff;
    }
  }
</style>
